export default function NotFound() {
  return (
    <div style={{ textAlign: "center", marginTop: 60 }}>
      <h1>404</h1>
      <p>Page Not Found</p>
      <a href="/" style={{ color: "blue" }}>
        Go to Home
      </a>
    </div>
  );
}